import sparkpostApiRequest from 'src/actions/helpers/sparkpostApiRequest';

const alertsV2Hheaders = {
  'X-MSYS-ALERTSV2': 1
};

export function listAlerts(isAlertsV2Req = false) {
  return sparkpostApiRequest({
    type: 'LIST_ALERTS',
    meta: {
      method: 'GET',
      url: '/v1/alerts',
      showErrorAlert: false,
      headers: isAlertsV2Req ? alertsV2Hheaders : {}
    }
  });
}

export function createAlert({ data }) {
  return sparkpostApiRequest({
    type: 'CREATE_ALERT',
    meta: {
      method: 'POST',
      url: '/v1/alerts',
      data
    }
  });
}

export function updateAlert({ data, id }) {
  return sparkpostApiRequest({
    type: 'UPDATE_ALERT',
    meta: {
      method: 'PUT',
      url: `/v1/alerts/${id}`,
      data
    }
  });
}

export function setMutedStatus({ muted, id }) {
  return sparkpostApiRequest({
    type: 'SET_ALERT_MUTED_STATUS',
    meta: {
      method: 'PUT',
      url: `/v1/alerts/${id}`,
      data: { muted },
      id
    }
  });
}

export function deleteAlert({ id }) {
  return sparkpostApiRequest({
    type: 'DELETE_ALERT',
    meta: {
      method: 'DELETE',
      url: `/v1/alerts/${id}`,
      id
    }
  });
}

export function getAlert({ id }) {
  return sparkpostApiRequest({
    type: 'GET_ALERT',
    meta: {
      method: 'GET',
      url: `/v1/alerts/${id}`,
      showErrorAlert: false
    }
  });
}

export function getIncidents({ id }) {
  return sparkpostApiRequest({
    type: 'GET_ALERT_INCIDENTS',
    meta: {
      method: 'GET',
      url: `/v1/alerts/${id}/incidents`,
      showErrorAlert: false
    }
  });
}

export function listIncidents(isAlertsV2Req = false) {
  return sparkpostApiRequest({
    type: 'LIST_ALERTS_INCIDENTS',
    meta: {
      method: 'GET',
      url: `/v1/alerts/incidents`,
      showErrorAlert: false,
      headers: isAlertsV2Req ? alertsV2Hheaders : {}
    }
  });
}
